import * as yup from 'yup';
import { pick } from 'lodash';
import { Person } from '../../../../global/entities/Person';
import { YupKeyRecord } from '../../../../utils/types';
import {
  CostStatementFormState,
  CostStatementPerson,
  CostStatementReceiveOption,
} from './cost-statement-types';

export const costStatementValidationSchema = yup
  .object()
  .shape<YupKeyRecord<CostStatementFormState>>({
    receiveOption: yup
      .string()
      .required('Välj ett av alternativen')
      .matches(/^(email|mail)$/),
    receiverEmails: yup.mixed().when('receiveOption', {
      is: (val) => val === 'email',
      then: yup.string().required('Vänligen ange en e-postadress'),
    }),
    invoiceRecipient: yup
      .string()
      .nullable()
      .required('Fakturamottagare krävs'),
  });

export const CostStatementReceiveLabel: Record<
  CostStatementReceiveOption,
  string
> = {
  email: 'Via epost, digital signatur med e-legitimation',
  mail: 'Via post, underskrift på papper',
};

export const mapPerson = (person: Person): CostStatementPerson =>
  pick(person, 'socialSecurityNumber', 'firstName', 'lastName');

export const getReceiverEmailsDefaultValue = (
  people: CostStatementPerson[],
) => {
  if (people.length === 0) return '';

  const formatPerson = ({
    socialSecurityNumber,
    lastName,
    firstName,
  }: CostStatementPerson) =>
    `${firstName} ${lastName} (${socialSecurityNumber}): ange.epost@exempel.se`;

  return people.map(formatPerson).join('\n');
};
